import InternCoursePage from '../InternCoursePage';
import useInternCourses from '../../../../hooks/useInternCourses';

export default function InternSpecialCoursesPage() {
  const { courses, loading, error, reload } = useInternCourses('special');
  return (
    <InternCoursePage
      courses={courses}
      loading={loading}
      error={error}
      pageTitle={'TCE-Kurse'}
      category={'special'}
      reload={reload}
    />
  );
}
